import React from 'react';
import GridContainer from '../../../@jumbo/components/GridContainer';
import PageContainer from '../../../@jumbo/components/PageComponents/layouts/PageContainer';
import Box from '@material-ui/core/Box';
import IntlMessages from '../../../@jumbo/utils/IntlMessages';
import Grid from '@material-ui/core/Grid';

const breadcrumbs = [
  { label: 'Home', link: '/' },
  { label: 'Menus Page', isActive: true },
];

const Menus = () => {
  return (
    <PageContainer heading={<IntlMessages id="pages.Menus" />} breadcrumbs={breadcrumbs}>
      <GridContainer>
        <Grid item xs={12}>
          <Box>
            {/* <h1>Comming Soon</h1> */}
            <IntlMessages id="pages.Menus" />
            <p>this is Menus page</p>
          </Box>
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default Menus;
